import { render, staticRenderFns } from "./productspretrainreal.vue?vue&type=template&id=8d207d28&"
import script from "./productspretrainreal.vue?vue&type=script&lang=js&"
export * from "./productspretrainreal.vue?vue&type=script&lang=js&"
import style0 from "./productspretrainreal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports